// @flow
import * as React from "react";
import tw from "tailwind-styled-components";
import Button from "ui/atoms/Button";
import Flex from "ui/atoms/Flex";
import FlexBox from "ui/atoms/FlexBox";
import Footer from "ui/atoms/Footer";

type Props = {
  children?: React.Node,
  primaryButton?: boolean,
  primaryButtonText?: string,
  primaryButtonOnClick?: () => ?null,
};

const FooterBody = tw.div`
  max-w-screen-xl
  mx-auto
  px-3
`;

function PageFooter({
  children,
  primaryButton,
  primaryButtonText,
  primaryButtonOnClick = () => null,
  ...props
}: Props): React.Node {
  return (
    <Footer $flex {...props}>
      <FlexBox>
        <FooterBody>
          <Flex $flexDirection="row" align="center" justify="end">
            {children}
            {primaryButton && (
              <Button $primary onClick={primaryButtonOnClick}>
                {primaryButtonText || "Save"}
              </Button>
            )}
          </Flex>
        </FooterBody>
      </FlexBox>
    </Footer>
  );
}

export default PageFooter;
